import { render, staticRenderFns } from "./getCollectMlinesPage.vue?vue&type=template&id=4b32366d&scoped=true"
import script from "./getCollectMlinesPage.vue?vue&type=script&lang=js"
export * from "./getCollectMlinesPage.vue?vue&type=script&lang=js"
import style0 from "./getCollectMlinesPage.vue?vue&type=style&index=0&id=4b32366d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32366d",
  null
  
)

export default component.exports